import React, { useContext, useState } from "react";
import QuizQuestionItem from "../components/questions/QuizQuestionItem";
import { SectionsContext } from "../context/SectionsContext";
import { AttempsContext } from "../context/AttemptsContext";
import { CoursesContext } from "../context/CoursesContext";
import { ModalContext } from "../context/ModalContext";
import img from "../assets/images/bg-tbm-online.jpeg";
import { S3_ENDPOINT } from "../utils";
import "../css/SingleCurso.css";
import "../css/quiz.css";

const QuizQuestion = ({
  spinner,
  attempt,
  questions,
  setAnswer,
  attempt_id,
  user_answers,
  saveUserAnswer,
  handleCallback,
}) => {
  const { course } = useContext(CoursesContext);
  const { section } = useContext(SectionsContext);
  const { finishAttempt } = useContext(AttempsContext);
  const { alert, clearModal, modalComponent } = useContext(ModalContext);
  const [savingQuestionId, setSavingQuestionId] = useState(null);

  // A final exam points at a course directly; a quiz hangs off a section.
  const isFinalExam =
    attempt?.test?.course_id !== null && attempt?.test?.course_id !== undefined;

  const getSrc = () => {
    if (course && course !== null) {
      if (course.course_id === 1) {
        return `${S3_ENDPOINT}/quiz-sculpt.jpg`;
      } else if (course.course_id === 2) {
        return `${S3_ENDPOINT}/quiz-barre.jpg`;
      } else if (course.course_id === 3) {
        return `${S3_ENDPOINT}/jump-examen.JPG`;
      } else if (course.course_id === 6) {
        return `${S3_ENDPOINT}/quiz-bbp.jpg`;
      }
    }
    return `${S3_ENDPOINT}/tbm-certs-bg.jpg`;
  };

  const handleFinish = () => {
    const invalidQuestions = questions.filter((question) => {
      const currentAnswer = (user_answers || []).find(
        (answer) => answer.question_id === question.question_id
      );
      if (!currentAnswer || currentAnswer === null) return true;
      return (
        !currentAnswer.content ||
        currentAnswer.content === null ||
        String(currentAnswer.content).includes("[object Object]")
      );
    });
    if (invalidQuestions.length) {
      clearModal();
      return alert(
        `Aún tienes preguntas por responder o con respuestas inválidas. Revisa las preguntas: ${invalidQuestions
          .map(({ order }) => order)
          .join(", ")}`
      );
    }
    finishAttempt(attempt_id, user_answers);
  };

  const handleSubmit = () => {
    modalComponent(
      "Terminar Quiz",
      <div>
        <p>
          ¿Estás segura que deseas terminar tu quiz? Esto calificará tus
          respuestas y recibirás un resultado que no se puede modificar.
        </p>
        <div className="row">
          <div className="col-6">
            <button onClick={clearModal} className="btn text-muted w-100">
              Cancelar
            </button>
          </div>
          <div className="col-6">
            <button onClick={handleFinish} className="btn btn-primary w-100">
              Terminar
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleSave = (question) => {
    const currentAnswer = user_answers.find(
      (answer) => answer.question_id === question.question_id
    );
    if (currentAnswer) {
      // Track which question is saving so only its button shows the spinner.
      setSavingQuestionId(question.question_id);
      // A file answer is held locally as a File object but stored as an S3
      // url, so it also needs the refetch to render the uploaded video.
      const isFile = typeof currentAnswer.content === "object";
      saveUserAnswer({ ...currentAnswer, attempt_id }, () => {
        setSavingQuestionId(null);
        if (isFinalExam || isFile) handleCallback();
      });
    }
  };

  const renderCourse = () => {
    if (course && course !== null) {
      return course.name;
    }
    return "Curso";
  };

  const renderSection = () => {
    if (section && section !== null) {
      return (
        <div>
          <div className="h2">{section.name}</div>
          <div className="small">{section.description}</div>
        </div>
      );
    }
  };

  const renderQuestions = () =>
    questions.map((question) => (
      <QuizQuestionItem
        key={question.question_id}
        spinner={spinner && savingQuestionId === question.question_id}
        disabled={spinner}
        question={question}
        questions={questions}
        setAnswer={setAnswer}
        user_answers={user_answers}
        handleSave={handleSave}
      />
    ));

  return (
    <div className="container-fluid d-flex flex-column flex-grow-1 px-4 px-lg-5 ps-lg-5 bg-accent">
      <div className="d-flex flex-column flex-grow-1 align-items-center">
        <div className="mt-5 h2">{renderCourse()}</div>
        {renderSection()}
        <div className="shadow bg-white mt-3 mb-5">
          <div className="row">
            <div className="col-12 col-md-4 col-xl-6 d-flex px-0">
              <img
                src={getSrc()}
                alt="quiz"
                style={{ objectFit: "cover" }}
                className="w-100 h-100 d-block quiz-img"
              />
            </div>
            <div className="col-12 col-md-8 col-xl-6">
              <div className="px-4 py-4 ps-md-3 pe-md-5 py-md-5">
                {renderQuestions()}
                <button
                  className="btn btn-primary shadow w-100"
                  onClick={handleSubmit}
                >
                  Terminar {isFinalExam ? "examen" : "quiz"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizQuestion;
